
define('text!areas/home/views/tiles/part-1x1-nodata.template.html',[],function () { return '<div class="nodata">\r\n\t<div class="fa fa-icon fa-fw fa-4x tile-icon gray-text" data-bind="css: data.icon"></div>\r\n\t<div class="text gray-text" data-bind="text: data.message"></div>\r\n</div>\r\n';});

